import { useMemo } from 'react';

import { PointChangeFragment } from '@occc/graphql';
import { PointChangeViewFooter } from '@occc-app/routes/Transactions/PointChangeView/PointChangeViewFooter';
import { readableDateWithShortTimezone } from '@occc-app/lib/format';
import { displayAmount } from '@occc-app/lib/currency';
import { PointChangeViewHeader } from './PointChangeViewHeader';
import { PointChangeViewItems } from './PointChangeViewItems';
import {
  getPointChangeItem,
  isLoyaltyEventPointChange,
  isManualAdjustmentPointChange,
} from './utils';

export const PointChangeView = ({ pointChange }: { pointChange: PointChangeFragment }) => {
  const { id, createdAt, pointAdjustmentReason, notes, quantity } = pointChange;

  const items = useMemo(() => {
    return [getPointChangeItem(pointChange)];
  }, [pointChange]);

  const awardedBy = isManualAdjustmentPointChange(pointChange)
    ? pointChange.source?.email
    : isLoyaltyEventPointChange(pointChange)
    ? `LoyaltyEvent - ${pointChange.source.id}`
    : undefined;

  const hasOffer = items.some((item) => !!item.offer);

  const donation = items[0].donation;
  const donationAmount = donation ? displayAmount(donation.donationAmountCents) : undefined;

  return (
    <>
      <PointChangeViewHeader
        id={id}
        amount={quantity}
        time={readableDateWithShortTimezone(createdAt)}
        adjustmentReason={
          (pointAdjustmentReason?.description || pointAdjustmentReason?.label) ?? undefined
        }
        awardedBy={awardedBy}
        award={items[0].award}
        donationAmount={donationAmount}
        notes={notes ?? undefined}
      />
      <PointChangeViewItems items={items} />
      {quantity < 0 && hasOffer && (
        <PointChangeViewFooter title='Total Points Spent' amount={quantity} />
      )}
    </>
  );
};
